// Create subscription
export const CREATE_SUBSCRIPTION_REQUEST = "CREATE_SUBSCRIPTION_REQUEST";
export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS";
export const CREATE_SUBSCRIPTION_FAILURE = "CREATE_SUBSCRIPTION_FAILURE";

// Get subscription details
export const GET_SUBSCRIPTION_DETAILS_REQUEST = "GET_SUBSCRIPTION_DETAILS_REQUEST";
export const GET_SUBSCRIPTION_DETAILS_SUCCESS = "GET_SUBSCRIPTION_DETAILS_SUCCESS";
export const GET_SUBSCRIPTION_DETAILS_FAILURE = "GET_SUBSCRIPTION_DETAILS_FAILURE";

// Get subscription history
export const GET_SUBSCRIPTION_HISTORY_REQUEST = "GET_SUBSCRIPTION_HISTORY_REQUEST";
export const GET_SUBSCRIPTION_HISTORY_SUCCESS = "GET_SUBSCRIPTION_HISTORY_SUCCESS";
export const GET_SUBSCRIPTION_HISTORY_FAILURE = "GET_SUBSCRIPTION_HISTORY_FAILURE";

// Get subscription history by ID
export const GET_SUBSCRIPTION_HISTORY_BY_ID_REQUEST = "GET_SUBSCRIPTION_HISTORY_BY_ID_REQUEST";
export const GET_SUBSCRIPTION_HISTORY_BY_ID_SUCCESS = "GET_SUBSCRIPTION_HISTORY_BY_ID_SUCCESS";
export const GET_SUBSCRIPTION_HISTORY_BY_ID_FAILURE = "GET_SUBSCRIPTION_HISTORY_BY_ID_FAILURE";

// Get subscription status
export const GET_STATUS_REQUEST = "GET_STATUS_REQUEST";
export const GET_STATUS_SUCCESS = "GET_STATUS_SUCCESS";
export const GET_STATUS_FAILURE = "GET_STATUS_FAILURE";
export const CLEAR_STATUS = "CLEAR_STATUS";
// Customer Portal
export const CREATE_CUSTOMER_PORTAL_REQUEST = "CREATE_CUSTOMER_PORTAL_REQUEST";
export const CREATE_CUSTOMER_PORTAL_SUCCESS = "CREATE_CUSTOMER_PORTAL_SUCCESS";
export const CREATE_CUSTOMER_PORTAL_FAILURE = "CREATE_CUSTOMER_PORTAL_FAILURE";
